module.exports = {"230405001":"兴安路街道","230405002":"兴建路街道","230405003":"兴长路街道","230405004":"峻德路街道","230405005":"河东路街道","230405006":"光宇街道","230405100":"红旗镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230405.json
// module id = 807
// module chunks = 0